<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div id="azureReportingDetails" class="subBlockContainer entry-loader">
    <div class="">
        <div class="inner-subBlock-wrapper">
            <div class="page-title-wrapper">
              <div class="title blade-title-font">
                {{title}}
              </div>
              <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
            </div>
          </div>
    </div>
    
    <div class="inner-subBlock-content">
      <div class="inner-subBlock-wrapper" *ngIf="loadContent && details?.length === 0">
          <div class="no-subs-panel">
            <div>
                <img src="../../images/new_ui/no-subscription.png">
              </div>
            <label class="no-subs-label">
              We couldn't find any <br />
              records for this tenant
            </label>

          </div> 
        </div>
        
        <div class="inner-subBlock-wrapper">
            <div class="filter-wrapper">
                <div class="col-md-3">
                  <div class="searchInputGroup">
                    <div class="searchIcon">
                      <img src="../../images/new_ui/filter.png">
                    </div>
                    <input class="searchInput" type="text" placeholder="Filter" [(ngModel)]="searchField">
                  </div>
                </div>
                <div class="col-md-3">
                    <div id="btnDownload" class="basic-icon download-icon download-icon-margin" placement="top" ngbTooltip="Download Excel" (click)="downloadUsageReport()"></div>
                </div>
              </div>
              <div class="row">
                  <div class="shared-outer-wrapper" *ngIf="details?.length">
                      <table class="table-width" matSort (matSortChange)="sortData($event)">
                          <thead>
                            <tr class="row order-title-wrapper">
                              <th class="col align-center" mat-sort-header="category">CATEGORY</th>
                              <th class="col align-center" mat-sort-header="subCategory">SUB CATEGORY</th>
                              <th class="col align-center" mat-sort-header="resourceName">RESOURCE NAME</th>
                              <th class="col align-center" mat-sort-header="usageStartDate">USAGE DATE</th>
                              <th class="col align-center" mat-sort-header="unit">UNIT</th>
                              <th class="col align-right" mat-sort-header="quantityUsed">QTY</th>
                              <th class="col align-right" mat-sort-header="totalCost">TOTAL</th>
                            </tr>
                          </thead>
                          <tbody class="scrollable-table-body">
                             <ng-container *ngFor="let item of sortedData | TableFilterMultiple: ['category', 'subCategory', 'resourceId', 'resourceName'] : searchField">
                               <tr class="row order-content-wrapper">
                                 <td class="col-md align-left">{{ item.category }}</td>
                                 <td class="col-md align-left">{{ item.subCategory }}</td>
                                 <td class="col-md align-left">{{ item.resourceName }}</td>
                                 <td class="col-md align-left">{{ item.usageStartDate | date: 'yyyy-MM-dd' }}</td>
                                 <td class="col-md align-center">{{ item.unit }}</td>
                                 <td class="col-md align-right">{{ item.quantityUsed }}</td>
                                 <td class="col-md align-right" >{{ item.unitSellPrice | currency:'AUD':'symbol-narrow':'.2-2' }}</td>
                               </tr>
                             </ng-container>
                          </tbody>
                      </table>
                  </div>
              </div>
        </div>

        <loading-screen [hidden]="loadContent" [isScrolled]="true" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)"></loading-screen>
    </div>
</div>

